import styled from "styled-components";

export const StyledInput = styled.input`
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;
  height: 30px;
  border-radius: 5px;
  outline: none;
  padding: 10px;
  border: none;
  background-color: #e7ffec;
  box-shadow: 0px 0px 2px 1px #178e1c;
  font-size: 15px;
  font-weight: bold;
  font-family: "Roboto";
  color: #178e1c;
  -webkit-appearance: none;
`;
